import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const scatterChartDescription: CalculatorDescription = {
  id: CalculatorId.ScatterChart,
  title: 'Scatter Plot Maker',
  metaTitle: 'Free Online Scatter Plot Maker - Create Point Graphs',
  description: 'Generate scatter plots to visualize relationships between two variables. Perfect for correlation analysis, trend identification, and pattern recognition.',
  metaDescription: 'Create scatter plots online. Visualize data correlations and patterns with our free tool. Perfect for analyzing relationships between variables.',
  howTo: {
    title: 'How to Create a Scatter Plot',
    steps: [
      'Enter your data directly into the table or upload a CSV file',
      'Use the "X-axis column" control to select which numeric column to use for the horizontal axis',
      'Use the "Y-axis column" control to select which numeric column to use for the vertical axis',
      'Add a title to your chart using the "Chart title" field',
      'Customize the appearance with the "Appearance" tab options including marker size and trend line type (none, linear, polynomial, or exponential)'
    ],
    graphic: {
      description: 'An echarts scatter plot with optional trend line, with a shadcn table for x-y data entry'
    }
  },
  examples: [
    {
      title: 'Height vs Weight',
      description: 'Bivariate normal distribution',
      dataDescription: 'Height and weight measurements',
      insights: [
        'Shows correlation between variables',
        'Identifies outliers',
        'Displays clustering patterns',
        'Visualizes data distribution'
      ]
    },
    {
      title: 'Cost vs Performance',
      description: 'Positive correlation analysis',
      dataDescription: 'Cost and performance metrics',
      insights: [
        'Shows value relationships',
        'Highlights optimal points',
        'Identifies performance trends',
        'Guides decision making'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.XYPlot,
    CalculatorId.BarGraph,
    CalculatorId.LineChart
  ]
}; 